import {NextRouter} from "next/router";
import {enforceArray, sortingOption} from "../../helpers/FilterFunctions";
import {Filter, FilterAnyLabels} from "./Filter.config";
import {VermietungCategories} from "./VermietungFilter.config";

export const VerkaufAusstattungItems = (
	router: NextRouter,
	startpage?: boolean
) => {
	return {
		label: VermietungCategories.Ausstatung.label,
		items: [
			{
				primaryLabel: Filter.Pool.label,
				id: Filter.Pool.label,
				checked: router.query[Filter.Pool.queryKey] ? true : false
			},
			{
				primaryLabel: Filter.Mooring.label,
				id: Filter.Mooring.label,
				checked: router.query[Filter.Mooring.queryKey] ? true : false
			},
			{
				primaryLabel: Filter.Garage.label,
				id: Filter.Garage.label,
				checked: router.query[Filter.Garage.queryKey] === "1" ? true : false
			},
			{
				primaryLabel: Filter.ViewSea.label,
				id: Filter.ViewSea.label,
				checked: router.query[Filter.ViewSea.queryKey] === "1" ? true : false
			}
		]
	};
};

export const VerkaufLageItems = (router: NextRouter, startpage?: boolean) => {
	return {
		label: VermietungCategories.Lage.label,
		items: [
			{
				primaryLabel: Filter.ViewCanal.label,
				id: Filter.ViewCanal.label,
				checked: router.query[Filter.ViewCanal.queryKey] ? true : false
			},
			{
				primaryLabel: Filter.MooringBefore.label,
				id: Filter.MooringBefore.label,
				checked: router.query[Filter.MooringBefore.queryKey] ? true : false
			},
			{
				primaryLabel: Filter.SouthOrientation.label,
				id: Filter.SouthOrientation.label,
				checked:
					router.query[Filter.SouthOrientation.queryKey]?.toString() ===
					Filter.SouthOrientation.values?.toString()
						? true
						: false
			},
			{
				primaryLabel: Filter.NorthOrientation.label,
				id: Filter.NorthOrientation.label,
				checked:
					router.query[Filter.NorthOrientation.queryKey]?.toString() ===
					Filter.NorthOrientation.values?.toString()
						? true
						: false
			}
		]
	};
};

export const LivingAreaItems = (router: NextRouter) => {
	const {queryKey, label, values} = Filter.LivingArea;
	const obj = {
		title: label,
		items: values,
		singleChoice: true
	};

	if (!router.query[queryKey]) {
		return {...obj, defaultChecked: [FilterAnyLabels.BELIEBIG]};
	}

	const queryValue = enforceArray(router.query[queryKey]);
	console.log("LivingAreaItems", queryValue)
	return {
		...obj,
		defaultChecked: queryValue.map((v) => {
			return "min. " + v + " m²";
		})
	};
};

export const PlotSizeItems = (router: NextRouter) => {
	const {queryKey, label, values} = Filter.PlotSize;
	const obj = {
		title: label,
		items: values,
		singleChoice: true
	};

	if (!router.query[queryKey]) {
		return {...obj, defaultChecked: [FilterAnyLabels.BELIEBIG]};
	}

	const queryValue = enforceArray(router.query[queryKey]);
	console.log("PlotSizeItems", queryValue)
	return {
		...obj,
		defaultChecked: queryValue.map((v) => {
			return "min. " + v + " m²";
		})
	};
};

export const VerkaufSortingOptions: sortingOption[] = [
	{
		label: "sortingOptions.relevance"
	},
	{
		label: "sortingOptions.asc",
		queryKey: "sales_price_gross_eur",
		sortDirection: "asc"
	},
	{
		label: "sortingOptions.desc",
		queryKey: "sales_price_gross_eur",
		sortDirection: "desc"
	}
];
